import React from 'react';

import './fixed-background.css';

export default function FixedBackground(props) {
    
    return (
        <div className="fixed-background"></div>
    );
}